import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import MyPartyResponse from "./responses/apiResponses";
import { handleAxiosError, ApiResponse } from "./responses/AxiosResponseHandler";

class AcceptedApi {
  private authClient: AuthClient;
  constructor(authClient: AuthClient) {
    this.authClient = authClient;
  }

  public async getMyParties(): Promise<ApiResponse<MyPartyResponse[]> | undefined> {

    try {
      const authenticationResponse = this.authClient.getAuthenticationResponse();
      const cityID = authenticationResponse?.cityId;

      if (!cityID) {
        console.error("City ID is missing in the authentication response.");
        return undefined;
      }
      const token = authenticationResponse.token;
      const response = await axios.get(
        `${this.authClient.getApiRoot()}/groups/accepted`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return {
        statusCode: response.status,
        errorMessage: "",
        data: response.data as MyPartyResponse[],
      };

    } catch (error) {
      const errorResponse = handleAxiosError<MyPartyResponse[]>(error as AxiosError);
      return {
        statusCode: errorResponse.statusCode,
        errorMessage: errorResponse.errorMessage,
        data: errorResponse.data
      }
    }
  }
}

export default AcceptedApi;
